import Zendesk from 'react-zendesk';
import { lightTheme } from '../../../styles/GlobalStyles';

const setting = {
  color: {
    theme: lightTheme.colors.primary900
  },
  launcher: {
    chatLabel: {
      'en-US': 'Need Help'
    }
  },
  contactForm: {
    fields: [
      { id: 'description', prefill: { '*': 'My pre-filled description' } }
    ]
  }
};
const ZENDESK_KEY = 'e670a36b-6132-4f34-808a-eca19199f692';

interface CheckboxProps {}

export const ZendeskWidget = () => {
  return (
    <Zendesk
      defer
      zendeskKey={ZENDESK_KEY}
      {...setting}
      onLoaded={() => console.log('is loaded')}
    />
  );
};
